<template lang="jade">
  .container-fluid
    .row
      .status_main.col-md-12
        header.status_title_bar.main_title_bar.clearfix
          h1.title.col-lg-10.col-md-10.col-sm-10.col-xs-10 status
          //- .function_group.col-md-2.col-xs-2
          //-   .function__single.col-md-12.no_pad
          //-     i.fa.fa-cog.fa-2x(v-on:click='handleShowModal')
        section.status_content.col-lg-12.col-md-12.col-sm-12.col-xs-12.no_pad
          header.output_header.clearfix
            h2.title_bar.col-lg-5.col-md-5.col-sm-7 Digital Outputs
            //- h2 {{DOs | json}}
          section.output_content.col-md-12.col-lg-9.clearfix
            .col-md-3.output__single.clearfix.row_space--xxs(v-for='(key, card) in DOs')
              .card.col-md-12.no_pad
                .card_header.col-md-12.clearfix
                  span.key {{key}}
                  span.name {{card.name}}
                  span.setting
                    i.fa.fa-cog(v-on:click="handleShowModal(true, key)")
                .card_body.col-md-12.clearfix
                  .btn_group.col-md-5.col-centered
                    span
                      .mask(v-on:click.self='setDOStatus(key)')
                      label.iosCheck.longer
                        input(type="checkbox" v-bind:checked.sync="card.value === 'high'")
                        i
                          span.on(v-bind:class="{addOpacity: card.value !== 'high'}") On
                          span.off(v-bind:class="{addOpacity: card.value === 'high'}") Off
          header.input_header.clearfix
            h2.title_bar.col-lg-5.col-md-5.col-sm-7 Digital Inputs
            //- h2 {{DIs | json}}
          section.input_content.col-md-12.col-lg-9.clearfix.no_pad-xs
            .col-md-3.col-xs-6.input__single.row_space--xxs.clearfix(v-for='(key, card) in DIs')
              .card.col-md-12.no_pad
                .card_header.col-md-12.clearfix
                  span.key {{key}}
                  span.name {{card.name}}
                  span.setting
                    i.fa.fa-cog(v-on:click="handleShowModal(false, key)")
                .card_body.col-md-12.clearfix
                  button.btn(v-bind:class="{'enabled': card.value === 'high'}" disabled)
    modal.config_modal(
      title='DIO Config'
      v-bind:show.sync='showModal'
      v-bind:callback='applyConfig'
      effect='zoom'
      ok-text='Apply'
      cancel-text='Cancel')
      .modal-body.clearfix(slot='modal-body')
        section.di_name_group.clearfix(v-if="!isOut")
          .di__name__single.col-md-12.clearfix
            label DI {{currentIndex}}
            input.form-control(v-model='editing.DIs[currentIndex].name' maxlength='7')
        section.do_name_group.clearfix(v-else)
          .do__name__single.col-md-12.clearfix
            label DO {{currentIndex}}
            input.form-control(v-model='editing.DOs[currentIndex].name' maxlength='7')

</template>

<script>
import { call } from 'src/Service.js'
import { modal } from 'vue-strap'
import _ from 'lodash'

export default {
  components: {
    modal
  },
  data () {
    return {
      DIs: {},
      DOs: {},
      editing: {
        DIs: {},
        DOs: {}
      },
      isOut: false,
      currentIndex: -1,
      showModal: false
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    call(mac, 'dxGetDIOStatus').then(({channels}) => {
      this.DIs = channels.DIs
      this.DOs = channels.DOs
    }).catch(err => {
      this.alert('danger', '', err)
    })
  },
  computed: {
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    setDOStatus (key) {
      let { mac } = this.$route.params
      let params = {
        'DOs': {
          [key]: {
            value: this.DOs[key].value === 'high' ? 'low' : 'high'
          }
        }
      }
      call(mac, 'dxSetDOState', params).then(res => {
        console.log(res)
      }).catch(err => {
        this.alert('danger', '', err)
      })
    },
    handleShowModal (isOut, index) {
      this.isOut = isOut
      this.currentIndex = index
      if (this.isOut) {
        this.editing.DOs = _.cloneDeep(this.DOs)
      } else {
        this.editing.DIs = _.cloneDeep(this.DIs)
      }
      this.showModal = true
    },
    allNameValid () {
      let regex = /^[0-9A-Za-z\s_]{1,}$/
      if (this.isOut) {
        return regex.test(this.editing.DOs[this.currentIndex].name)
      } else {
        return regex.test(this.editing.DIs[this.currentIndex].name)
      }
      // for (let key in this.editing.DIs) {
      //   if (!regex.test(this.editing.DIs[key].name)) {
      //     return false
      //   }
      // }
      // for (let key in this.editing.DOs) {
      //   if (!regex.test(this.editing.DIs[key].name)) {
      //     return false
      //   }
      // }
      // return true
    },
    applyConfig () {
      if (!this.allNameValid()) return this.alert('danger', '', 'One of the names is invalid.')
      let DOs = {}
      let DIs = {}
      let { mac } = this.$route.params

      for (let key in this.editing.DIs) {
        if (this.editing.DIs[key].name !== this.DIs[key].name) {
          Object.defineProperty(DIs, `${key}`, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
              name: this.editing.DIs[key].name
            }
          })
        }
      }

      for (let key in this.editing.DOs) {
        if (this.editing.DOs[key].name !== this.DOs[key].name) {
          Object.defineProperty(DOs, `${key}`, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
              name: this.editing.DOs[key].name
            }
          })
        }
      }
      // start to pack the changed DIO names
      let DOAry = Object.keys(DOs)
      let DIAry = Object.keys(DIs)
      let params

      if (DOAry.length !== 0 && DIAry.length !== 0) {
        params = {
          DOs: DOs,
          DIs: DIs
        }
      } else if (DOAry.length !== 0) {
        params = {
          DOs: DOs
        }
      } else if (DIAry.length !== 0) {
        params = {
          DIs: DIs
        }
      }
      console.log(params)
      if (params) {
        call(mac, 'dxSetDIOConfig', params).then(res => {
          console.log(res)
        }).catch(err => {
          this.alert('danger', '', err)
        })
      } else {
        this.alert('success', '', 'Nothing changed')
      }

      this.showModal = false
    }
  }, // close methods
  ready () {
  },
  watch: {
    showModal (nV) {
      if (!nV) {
        this.editing = {
          DIs: {},
          DOs: {}
        }
      }
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      if (type === 'state' || type === 'info') {
        let newDIOs = _.cloneDeep(this[event.type])
        let key = type === 'state' ? 'value' : 'name'
        newDIOs[event.id][key] = event[key]
        this[event.type] = _.cloneDeep(newDIOs)
      }
    }
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.function_group{
  position:fixed;
  z-index: 55;
  right:15px;
  text-align:center;
  @include breakpoint(xs) {
    padding-top: $space_xxs;
  }
}

.output_header{
  padding-top: $space_xs;
}


// .card
.card{
  width:100%;
  border:1px solid $DioStatus_card_border;
  border-radius: $base_border_radius;
  overflow: hidden;
  color: $DioStatus_card_fg;
  background-color: $DioStatus_card_bg;
  .card_header{
    padding: 5px 15px;
    white-space:nowrap;
    color: $DioStatus_card_header_fg;
    background-color: $DioStatus_card_header_bg;
    .key{
      display:inline-block;
      width:10%;
    }
    .name{
      display:inline-block;
      text-transform:capitalize;
      text-align:center;
      width:80%;
    }
  }
  .card_body{
    position: relative;
    height:120px;
    @include breakpoint(iFive) {
      height:70px;
    }
    .btn{
      outline:none;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width:30px;
      height:30px;
      border-radius:50%;
      padding:0;
      background-color:$pri_gray;
    }
    .enabled.btn{
      background-color:$pri_green;
    }
    .btn_group{

      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width:80%;
      @include breakpoint(md){
        width:100%;
        padding-left: 0;
        padding-right: 0;
      }
      @include breakpoint(lg){
        width:100%;
      }
      height:100%;
      padding-top:20px;
      @include breakpoint(sm) {
        padding-top:40px;
      }
      @include breakpoint(md) {
        padding-top: 40px;
      }
      @include breakpoint(lg){
        padding-top: 45px;
      }
      text-align:center;
      & > span{
        display:inline-block;
        vertical-align:middle;
        position: relative;
        .mask{
          cursor:pointer;
          position: absolute;
          width:100%;
          height:100%;
          z-index: 5;
        }
      }
      .iosCheck{
        margin-left: $space_sm;
        margin-right: $space_sm;

        @include breakpoint(lg){
          margin-left: $space_xs;
          margin-right: $space_xs;
        }
        @include breakpoint(md){
          margin-left: 3px;
          margin-right: 3px;
        }
      }
    }
  }
}

// modal

// modify iosCheck here
.iosCheck :checked + i {
  background-color: darken(#B2ED44, 20%);
}
.iosCheck i{
  position: relative;

  & span{
    font-style: normal;
    font-weight: normal;
    position: absolute;
    top: 1px;
    transition: opacity .3s;
    opacity: 1;
    @include breakpoint(xs) {
      top: 5px;
    }
  }

  & .addOpacity {
    opacity: 0;
  }

  & .on {
    left: 5px;
    color: #fff;
  }

  & .off {
    right: 10px;
    color:#444
  }
}
</style>



// WEBPACK FOOTER //
// Status.vue?70bb9242